import React, { Component, createRef } from 'react';
import { IQuil, EModuleType } from '../../../models/components/input-quil.d';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // ES6
import 'react-quill/dist/quill.bubble.css'; // ES6
import { string, any } from 'prop-types';
import { Log } from 'ng2-logger';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import { Notification } from '../../../components/notification/main';
import Translator from '../../../core/i18n';

window.katex = katex;


let setModule: {};
const _logger = Log.create('Input-Text Choice');
const T = Translator.create();


export class Quil extends React.Component<IQuil> {
    public state = {
        text: '',
        setModule: any,
        onClickQuestionTextEditor: false,
        description: this.props.value,
    };

    componentDidUpdate(prevProps: Readonly<IQuil>, prevState: Readonly<{}>, snapshot?: any): void {
        if(this.props.value !== prevProps.value && this.props.value)
        {
            this.setState({description: this.props.value})
        }
    }

    private basicModules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['formula'], ['link'], ['clean']
        ],
    };

    private standartModules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image', 'formula'],
            ['clean']
        ],
    };

    private allModules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image', 'formula'],
            ['clean'], ['code-block'], ['video']
        ],
    };

    private mobileModules = { toolbar: [] };

    private formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link'
    ];

    constructor(props: any) {
        super(props);
        if (this.props.modules === EModuleType.basic) setModule = this.basicModules;
        else if (this.props.modules === EModuleType.standart) setModule = this.standartModules;
        else if (this.props.modules === EModuleType.all) setModule = this.allModules;
        else if (this.props.modules === EModuleType.mobile) setModule = this.mobileModules;
        else setModule = this.standartModules;
    }

    public onchange = (event: any, delta: any, source: any, editor: any) => {
        if (this.props.onChange) {
            let maxLength = 3503;
            let length = editor.getLength();
            if (length <= maxLength || this.props.id === 'examPreMessage') {
                if (this.props.theme && this.props.theme === 'bubble') {
                    this.onBubbleOffTheme();
                }
                this.setState({ description: event })
                this.props.onChange(event);
            }
            else {
                let maxCharErrorText : string = T.t('r_error_max_char_3500');
                if(this.props.type === 'chat')
                {
                    maxCharErrorText = T.t('r_error_max_char_message')
                }
                Notification.setNotification(
                    'error',
                    maxCharErrorText,
                    'topRight'
                );
                const value = event.substring(0, maxLength)
                this.setState({ description: value })
                this.props.onChange(value);
            }
        }
    }


    public onKeyPress = (event: any) => {
        if (this.props.onkeypress) {
            this.props.onkeypress(event);
        }
    }

    public onFocus = () => {
        if (this.props.readonly) {
            let errorText = T.t('r_error_simulate_message')

            if(this.props.type === 'forum')
            {
                 errorText = T.t('r_error_simulate_forum')
            }
            Notification.setNotification(
                'error',
                errorText,
                'topRight'
            );
            return;
        }
        if (!this.props.theme) {
            this.setState({ onClickQuestionTextEditor: true });
        }

        if (this.props.theme && this.props.theme === 'bubble') {
            this.onBubbleTheme();
        }
    }

    public onBlur = () => {
        if (!this.props.theme) {
            this.setState({ onClickQuestionTextEditor: false });
        }
    }

    public onBubbleTheme = () => {
        if (this.props.id) {
            const item = document.getElementById(this.props.id);

            if (item) {
                const tooltip = item.getElementsByClassName('ql-tooltip');

                if (tooltip && (tooltip[0].className === 'ql-tooltip ql-hidden' || tooltip[0].className === 'ql-tooltip ql-editing ql-hidden')) {
                    tooltip[0].className = 'ql-tooltip ';
                }
            }
        }
    }
    public onBubbleOffTheme = () => {
        if (this.props.id) {
            const item = document.getElementById(this.props.id);

            if (item) {
                const tooltip = item.getElementsByClassName('ql-tooltip');

                if (tooltip && (tooltip[0].className === 'ql-tooltip ql-hidden' || tooltip[0].className === 'ql-tooltip ql-editing ql-hidden')) {
                    tooltip[0].className = 'ql-tooltip ql-hidden';
                }
            }
        }
    }
    public render() {
        return (
            <div style={{ display: 'contents' }} onClick={this.onFocus} id={this.props.id ? this.props.id : ''} >
                <ReactQuill
                    value={this.state.description}
                    // value={this.state.description}
                    readOnly={(this.props.readonly) ? this.props.readonly : false}
                    placeholder={(this.props.placeholder) ? this.props.placeholder : ''}
                    modules={(setModule) ? setModule : this.standartModules}
                    style={{ width: '100%', height: '100%', position: 'relative' }}
                    onChange={this.onchange}
                    onKeyPress={this.onKeyPress}
                    theme={this.props.theme ? this.props.theme : (this.state.onClickQuestionTextEditor ? 'snow' : 'bubble')}
                    className={this.props.className}
                />
            </div>
        );
    }
}

export default Quil;
